<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/ordercustomermain"/>
    <Order_identify/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/agreement.png";
import Order_identify from "@/components/admin/sell/Order_identify";
export default {
  name: "OrderIdentify",
  components: {
    Order_identify,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
